module.exports = __webpack_public_path__ + "img/icon-light.7e268461.svg";